import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/news', name: 'News', component: () => import('@/views/News.vue') },
  { path: '/news/:id', name: 'NewsDetail', component: () => import('@/views/NewsDetail.vue') },
  { path: '/measure', name: 'Measure', component: () => import('@/views/Measure.vue') },
  { path: '/measure/:id', name: 'MeasureDetail', component: () => import('@/views/MeasureDetail.vue') }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
